import { Map } from 'immutable';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { reduxForm, FieldArray } from 'redux-form';
// import { connect } from 'react-redux';

import PendingUsersFieldArray from './PendingUsersFieldArray';
import UsersFieldArray from './UsersFieldArray';

@reduxForm({
  form: 'userForm',
  enableReinitialize: true,
})
export default class ProjectUserForm extends Component {
  static propTypes = {
    usersMap: PropTypes.instanceOf(Map).isRequired,
    handleSubmit: PropTypes.func,
    pristine: PropTypes.bool,
    submitting: PropTypes.bool,
    formObjectId: PropTypes.string,
    user: PropTypes.object.isRequired,
    dispatch: PropTypes.func,
    role: PropTypes.number,
    removeUserCallback: PropTypes.func,
    removePendingUserCallback: PropTypes.func,
    changeUserRoleCallback: PropTypes.func,
    pendingUsers: PropTypes.object,
    adminUserOnly: PropTypes.bool,
  };

  render() {
    const {
      usersMap,
      formObjectId,
      user,
      dispatch,
      removeUserCallback,
      removePendingUserCallback,
      changeUserRoleCallback,
      role,
      pendingUsers,
      adminUserOnly,
      // initialValues,
    } = this.props;

    const header =
      (<thead>
        <tr>
          <th>User</th>
          <th>Email</th>
          {/* <th>Company</th> */}
          <th>Role</th>
          <th>Pending</th>
          <th></th>
        </tr>
      </thead>);

    // console.log('initialValues: ', initialValues);

    let listUsers = null;
    // console.log('USERSMAP: ', usersMap);
    if (usersMap) {
      listUsers =
        (<FieldArray
          name="usersMap"
          component={UsersFieldArray}
          usersMap={usersMap.toIndexedSeq()}
          user={user}
          removeUserCallback={removeUserCallback}
          changeUserRoleCallback={changeUserRoleCallback}
          formObjectId={formObjectId}
          dispatch={dispatch}
          role={role}
          adminUserOnly={adminUserOnly}
        />);
    }

    let listPendingUsers = null;
    if (pendingUsers) {
      listPendingUsers =
        (<FieldArray
          name="pendingUsers"
          component={PendingUsersFieldArray}
          pendingUsers={pendingUsers.toIndexedSeq()}
          // usersMap={usersMap.toIndexedSeq()}
          user={user}
          removeUserCallback={removePendingUserCallback}
          // changeUserRoleCallback={changeUserRoleCallback}
          formObjectId={formObjectId}
          dispatch={dispatch}
          role={role}
        />);
    }

    return (
      <form>
        <table className="table table-sm table-striped">
          {header}
          {listUsers}
          {listPendingUsers}
        </table>
      </form>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/form/UserForm.js